import { Modal } from '@billy/design-system'
import { ReactElement } from 'react'

import { AutomaticPaymentRemindersType } from '@features/invoicingSettings/modules/paymentsAndReminders'

import { AutomaticPaymentRemindersAfterDueDate } from './elements/AutomaticPaymentRemindersAfterDueDate'
import { AutomaticPaymentRemindersBeforeDueDate } from './elements/AutomaticPaymentRemindersBeforeDueDate'
import { AutomaticPaymentRemindersEmailFields } from './elements/AutomaticPaymentRemindersEmailFields'

const paymentRemindersContentByType: Record<AutomaticPaymentRemindersType, ReactElement> = {
  [AutomaticPaymentRemindersType.AfterDueDate]: <AutomaticPaymentRemindersAfterDueDate />,
  [AutomaticPaymentRemindersType.BeforeDueDate]: <AutomaticPaymentRemindersBeforeDueDate />,
  [AutomaticPaymentRemindersType.OnDueDate]: <AutomaticPaymentRemindersEmailFields />,
}

interface AutomaticPaymentRemindersModalBodyProps {
  variant: AutomaticPaymentRemindersType
}

export const AutomaticPaymentRemindersModalBody = ({ variant }: AutomaticPaymentRemindersModalBodyProps) => {
  return <Modal.Body>{paymentRemindersContentByType[variant]}</Modal.Body>
}
